import { Component, HostBinding, OnInit, OnDestroy } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Event, NavigationStart, Route, Router, RouterOutlet } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {

  loginStatus: boolean = false;
  currentRoute: string = '';
  pageIsLogin: boolean = false;

  constructor(
    private _router: Router,
    private _authService: AuthService,
    private _navigationService: NavigationService,
  ) {
    this.pageIsLogin = (window.location.pathname == '/login' || window.location.hash == '#/login') ? true : false;
    this.currentRoute = '';
    this._router.events.subscribe((event: Event) => {
        if (event instanceof NavigationStart) {
            // Show progress spinner or progress bar
            this.loginStatus = this._authService.getLoginStatus();
            // console.log('Route change detected');
        }
    })
  }

  ngOnInit() {

  }

  ngOnDestroy() {

  }

  getBack() {
    this.pageIsLogin = true;
    this._navigationService.back('/login');
  }
}
